"use strict";

var names = ['Thor', 'Wonder Woman', 'Your Name Here'];
var nameContainer = document.getElementById('name');
var i = 0;
var timer;

var typingEffect = function typingEffect() {
  var name = names[i].split('');

  var loopTyping = function loopTyping() {
    if (name.length > 0) {
      if (nameContainer) {
        nameContainer.innerHTML += name.shift();
      }
    } else if (names.length > i + 1) {
      deletingEffect();
      return false;
    } else {
      return clearTimeout(timer);
    }

    ;
    timer = setTimeout(loopTyping, 400);
    return timer;
  };

  loopTyping();
};

var deletingEffect = function deletingEffect() {
  var name = names[i].split('');

  var loopDeleting = function loopDeleting() {
    if (name.length > 0) {
      name.pop();

      if (nameContainer) {
        nameContainer.innerHTML = name.join('');
      }
    } else {
      if (names.length > i + 1) {
        i += 1;
      } else {
        return clearTimeout(timer);
      }

      ;
      typingEffect();
      return false;
    }

    ;
    timer = setTimeout(loopDeleting, 200);
    return timer;
  };

  loopDeleting();
};

typingEffect();